import styled, {css, keyframes} from 'styled-components'
import {Modal, ModalBody} from '@/components/ui/modal-atoms/ModalAtoms.tsx'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ComboboxInput} from '@/components/ui/combobox-atoms/ComboboxAtoms'

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`

export const StyledConversationsModal = styled(Modal)(
    ({theme: {spacing}}) => css`
        top: ${spacing * 5}px;
        bottom: ${spacing * 5}px;
        right: ${spacing * 5}px;
        left: unset;
        transform: unset;
        display: grid;
        grid-template-rows: auto minmax(0, 1fr) auto;
        max-height: unset;
    `
)

export const StyledConversationsModalHeader = styled(Flexbox)(
    ({theme: {spacing, palette}}) => css`
        background-color: ${palette.neutral[50]};
        padding: ${spacing * 4}px;
    `
)

export const StyledConversationsModalSubheader = styled(Flexbox)(
    ({theme: {palette, spacing}}) => css`
        background-color: ${palette.neutral.white};
        padding: ${spacing * 2}px ${spacing * 4}px;
        border-bottom: 1px solid ${palette.neutral[200]};
    `
)

export const StyledConversationsModalBodyContainer = styled.div(
    () => css`
        position: relative;
        display: flex;
        flex-direction: column;
        min-height: 0;
    `
)

export const StyledConversationsModalBody = styled(ModalBody)(
    () => css`
        padding: 0;
        overflow: auto;
        min-height: 0;
        flex: 1;
    `
)

export const StyledConversationsModalBodyOverlay = styled.div(
    ({theme: {palette, opacities}}) => css`
        position: absolute;
        inset: 0;
        background: ${palette.neutral['600']}${opacities[40]};
        z-index: 1;
        animation: ${fadeIn} 200ms ease-out;

        @media (prefers-reduced-motion: reduce) {
            animation: none;
        }
    `
)

export const StyledConversationsModalFooter = styled(Flexbox)(
    ({theme: {spacing, palette}}) => css`
        padding: ${spacing * 4}px;
        background-color: ${palette.neutral.white};
        border-top: 1px solid ${palette.neutral[100]};
    `
)

export const StyledBorderlessComboboxInput = styled(ComboboxInput)(
    () => css`
        outline: none !important;
        box-shadow: none !important;
        border: none !important;
        background: transparent !important;
        border-radius: 0 !important;

        &:hover,
        &:focus,
        &:not(&:disabled):hover,
        &:not(&:disabled):focus {
            outline: none !important;
            box-shadow: none !important;
            border: none !important;
            background: transparent !important;
        }
    `
)
